'use client';

import { ReactNode, useRef } from 'react';
import { useUpdateAnchorInViewport } from './AlphabetizedAnchorInViewportContext';
import { AlphabetLetter } from './AlphabetAnchorLink.types';

export const AlphabetizedAnchorContainer = ({
	children,
	letter,
	className,
}: {
	children: ReactNode;
	letter: AlphabetLetter;
	className?: string;
}) => {
	const ref = useRef<HTMLDivElement>(null);

	useUpdateAnchorInViewport({ ref, letter });

	return (
		<div ref={ref} className={className}>
			{children}
		</div>
	);
};
